document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-content');
  const closeModal = document.getElementById('close-quick-view');

  document.querySelectorAll('.quick-view-btn').forEach(button => {
    button.addEventListener('click', function () {
      const handle = button.getAttribute('data-handle');
      modalContent.innerHTML = '<p>Loading…</p>';
      modal.style.display = 'flex';

      fetch(`/products/${handle}?view=quick-view`)
        .then(response => response.text())
        .then(html => {
          modalContent.innerHTML = html;
        })
        .catch(err => {
          modalContent.innerHTML = '<p>Failed to load product.</p>';
          console.error(err);
        });
    });
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });
});
